
import { useState, useEffect } from "react";
import { useUser, useAuth } from '@clerk/clerk-react'

/**
 * Get the current user's info, including their ID.
 * This hook will also handle the case where a user signs out or in
 *
 * @returns {{userId: string | null, userEmail: string | null, isLoading: boolean, isSignedIn: boolean}}
 * - The current user's id, loading state, and signed-in status.
 */
export const useUserInfo = () => {

  const { user } = useUser()
  const { isLoaded, isSignedIn } = useAuth()
  const [ userId, setUserId ] = useState(null)
  const [ userEmail, setUserEmail ] = useState(null)

  useEffect(() => {
    if (user && isLoaded && isSignedIn) {
      setUserId(user.id)
      setUserEmail(user.primaryEmailAddress?.emailAddress)
    } else {
      setUserId(null)
      setUserEmail(null)
    }
  }, [user, isLoaded, isSignedIn])

  return {
    userId,
    userEmail,
    user,
    isLoading: !isLoaded,
    isSignedIn
  }
}

export default useUserInfo
